import { ComponentProps } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import styles from './textField.module.scss';
import Label from '../../Label';

export const colorSchemeVariants = {
  default: styles.default,
  error: styles.error
};

const textFieldClass = cva(styles.textField, {
  variants: {
    colorScheme: {
      default: colorSchemeVariants.default,
      error: colorSchemeVariants.error
    },
    prefix: {
      true: styles.withPrefix
    }
  },
  defaultVariants: {
    colorScheme: 'default'
  }
});

const containerClass = cva(styles.container, {
  variants: {},
  defaultVariants: {}
});

export type TextFieldProps = ComponentProps<'input'> &
  VariantProps<typeof textFieldClass> & {
    fieldPrefix?: React.ReactNode;
    fieldSuffix?: React.ReactNode;
    label?: string;
    containerProps?: ComponentProps<'div'>;
  };

export default function TextField({
  className,
  label,
  containerProps,
  id,
  colorScheme,
  fieldPrefix,
  fieldSuffix,
  ...props
}: TextFieldProps) {
  const { className: containerClassName, ...otherContainerProps } =
    containerProps || {};

  return (
    <div
      className={containerClass({ className: containerClassName })}
      {...otherContainerProps}
    >
      {label && (
        <Label htmlFor={id} className={styles.label}>
          {label}
        </Label>
      )}
      {fieldPrefix && <div className={styles.prefix}>{fieldPrefix}</div>}
      <input
        id={id}
        className={textFieldClass({
          className,
          colorScheme,
          prefix: !!fieldPrefix
        })}
        {...props}
      />
      {fieldSuffix && <div className={styles.suffix}>{fieldSuffix}</div>}
    </div>
  );
}
